import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

/**
 * Gọi API lấy danh sách bề mặt đá
 * @param {Object} values Tham số truyền vào
 * @param {number} values.materialGroup ID nhóm vật liệu
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 */
export const fetchMaterialsByGroup = createAsyncThunk(
  'get/modules/v3/get_list_materials',
  async ({ offset, limit, materialGroup }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'modules/v3/get_list_materials',
        method: 'get',
        params: { offset, limit, material_group: materialGroup },
      });
      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data, total: response.count, offset };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API lấy nhóm mặt đá/kinh
 * @param {Object} values Tham số truyền vào
 * @param {number} values.productType Loại sản phẩm
 * @param {number} values.materialType Loại sản phẩm
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 */
export const fetchGroupMaterial = createAsyncThunk(
  'get/modules/v3/get_material_groups',
  async (
    { offset, limit, productType, materialType, supplier },
    { dispatch }
  ) => {
    try {
      const res = await callApi({
        endpoint: 'modules/v3/get_material_groups',
        method: 'get',
        params: {
          offset,
          limit,
          product_type: productType,
          material_type: materialType,
          supplier,
        },
      });
      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data, total: response.count, offset };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
